// Dictation in the iOS / Android app with the phone's own speech recognition (the
// browser's Web Speech API is missing in Android's web view). Same contract as the
// web path in DictateButton: the text so far arrives live, then the session ends.
import { SpeechRecognition } from '@capgo/capacitor-speech-recognition';
import { isNative } from './platform';

export async function nativeDictationAvailable() {
  if (!isNative()) return false;
  try {
    return (await SpeechRecognition.available()).available;
  } catch {
    return false;
  }
}

// The app's languages as the locales the phones' recognizers know.
const LOCALES = {
  ar: 'ar-SA', bn: 'bn-IN', de: 'de-DE', en: 'en-US', es: 'es-ES', fr: 'fr-FR', hi: 'hi-IN', id: 'id-ID',
  it: 'it-IT', ja: 'ja-JP', ko: 'ko-KR', mr: 'mr-IN', pl: 'pl-PL', pt: 'pt-BR', ru: 'ru-RU', sk: 'sk-SK',
  ta: 'ta-IN', te: 'te-IN', tr: 'tr-TR', ur: 'ur-PK', vi: 'vi-VN', zh: 'zh-CN',
};

/** Starts listening; onText(textSoFar), onEnd(). Resolves to a stop() function. */
export async function startNativeDictation(language, onText, onEnd) {
  const permission = await SpeechRecognition.requestPermissions();
  if (permission.speechRecognition !== 'granted') throw new Error('permission');
  const handles = [
    await SpeechRecognition.addListener('partialResults', (e) => {
      if (e.matches?.[0]) onText(e.matches[0]);
    }),
    await SpeechRecognition.addListener('listeningState', (e) => {
      if (e.state === 'stopped') finish();
    }),
  ];
  let done = false;
  function finish() {
    if (done) return;
    done = true;
    handles.forEach((h) => h.remove());
    onEnd();
  }
  SpeechRecognition.start({ language: LOCALES[language] || language, partialResults: true, popup: false,
    addPunctuation: true })
    .then((r) => { if (r?.matches?.[0]) onText(r.matches[0]); })
    .catch(() => finish());
  return async () => {
    await SpeechRecognition.stop().catch(() => {});
    finish();
  };
}
